<div class="container">
    <div class="row justify-content-center">
      <div class="col-12 col-sm-8">
        <div class="bolder spacing">
          Faculty Management
        </div>
        <div class="spacing spacing--sm">
          Click on column headers to sort the list accordingly.
        </div>
        <aaos-faculty-table></aaos-faculty-table>
  
      </div>
    </div>
  </div>